import { useEffect, useRef, useState } from "react";
import { Accordion } from "react-bootstrap";
import { AdminService } from "../../../../Services/Admin.service";

function loadScript(src, callback) {
    const baseUrl = process.env.REACT_APP_BASE_URL || "";  
    const script = document.createElement("script");
    // script.src = src;

    script.src = `${baseUrl}${src}`;
    script.onload = callback;
    document.body.appendChild(script);
}

function EmailFooter({ eventKey }) {
    const editorRef = useRef(null); // To hold the div reference for the editor
    const editorInstance = useRef(null); // To hold the editor instance
    const [footerMessage, setFooterMessage] = useState("");

    // Fetch email template list from AdminService
    function fetchAdminList() {
        const params = {
            type: "common",  // list | common  --- When common no need to pass type id
        };

        AdminService.getEmailTempletList(params)
            .then((response) => {
                if (response.success && response.data) {
                    const footerTemplate = response.data.list.find(item => item.identifier === "FOOTER");
                    if (footerTemplate) {
                        setFooterMessage(footerTemplate.message);
                    }
                }
            })
            .catch((error) => {
                console.error("Failed to fetch emailTemplate list", error);
            });
    }

    // Fetch the footer message on mount
    useEffect(() => {
        fetchAdminList();
    }, []); 
    
  const decodeHTML = (html) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = html;
    return textArea.value;
};
    // Initialize the rich text editor when the footerMessage changes
    useEffect(() => {
        loadScript("/richtexteditor/rte.js", () => {
            loadScript("/richtexteditor/plugins/all_plugins.js", () => {
                if (window.RichTextEditor) {
                    // Initialize the editor instance
                    editorInstance.current = new window.RichTextEditor(editorRef.current);
                    const decodedMessage = decodeHTML(footerMessage);
                    editorInstance.current.setHTMLCode(decodedMessage);
                    
                    // Cleanup on component unmount or when footerMessage changes
                    return () => {
                        if (editorInstance.current) {
                            editorInstance.current.destroy();
                        }
                    };
                }
            });
        });
    }, [footerMessage]);

    // Get the content from the editor
    const getEditorContent = () => {
        return editorInstance.current?.getHTMLCode() || "";
    };

    // Handle the update of the email footer
    const handleUpdateEmailFooter = async () => {
        const params = {
            template_id: 2,
            title: "Footer",
            subject: null,
            message: getEditorContent(),
            from: null,
            bcc: null,
            replyto: null,
            type_id: 1,
        };

        try {
            let response;
            response = await AdminService.updateEmailTempletList(params);
            if (response.success) {
                
            } else {
                 
            }
        } catch (error) {
            console.error("Failed to update email footer", error);
        }
    };

    return (
        <Accordion.Item eventKey={eventKey}>
            <Accordion.Header>
                <div style={{ marginRight: '15px' }}>
                    <b>Email Footer</b>
                </div>
            </Accordion.Header>
            <Accordion.Body>
                <>
                    <p>Use this section to manage the email footer for all email templates</p>
                    <br />
                    <p><b>Footer Text</b></p>
                    <div id="div_editor1" ref={editorRef}></div>
                    <button className="btn el-filled-btn mt-3" onClick={handleUpdateEmailFooter}>Save changes</button>
                </>
            </Accordion.Body>
        </Accordion.Item>
    );
}

export default EmailFooter;
